<template>
  <el-dialog :visible.sync="state" title="游戏选择" :close-on-click-modal="false" width="820px" @open="bindGetData">
    <div v-loading="loading" element-loading-text="加载中..." style="min-height: 200px">
      <!-- 选择游戏 -->
      <select-project-group-game
        ref="game"
        v-model="mult_game"
        :data="data"
        :gameGroupData="gameGroupData"
        :midGameData="midGameData"
        :visible="state"
        title="游戏"
        search
        @on-select="selectAll"
        @on-delete="delTag"
        @on-clear="clearTag"
      />
    </div>

    <!-- footer -->
    <template slot="footer">
      <div class="m-foot">
        <el-button @click="$emit('input', false)">取消</el-button>
        <el-button type="primary" :loading="asyning" @click="$emit('on-ok', mult_game)">
          <span v-if="asyning">提交中...</span>
          <span v-else>确认</span>
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>
<script>
import { findCheck, getNameOfData, clearTagOfData, isArray } from '@/common/js/utils'
import { getPtomGroupGames } from '@/api/material.model'
import { getMiddleGameList } from '@/api/common.model'
import selectProjectGroupGame from './game/select-project-group-game.vue'

export default {
  name: 'ProjectGroupGameSet',
  components: { selectProjectGroupGame },
  props: {
    value: {
      type: Boolean
    },
    data: {
      type: Array
    },
    gameIds: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    asyning: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    state: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    mult_game() {
      return findCheck(this.data)
    }
  },
  watch: {
    gameIds: {
      handler(nVal, oVal) {
        this.data.forEach((ret) => {
          if (nVal.includes(ret.id)) {
            this.$set(ret, 'check', true)
          }
        })
      },
      deep: true
    }
  },
  methods: {
    bindGetData() {
      this.data.forEach((ret) => {
        this.$set(ret, 'check', false)
      })
    },
    // 全选
    selectAll({ list, check = true }) {
      console.log(check)
      const data = list
      data.forEach((ret) => {
        this.$set(ret, 'check', check)
      })
    },
    // 删除已选
    delTag({ list, name }) {
      const data = getNameOfData(list, name)
      if (data.children && data.children.length) {
        this.selectAll({ list, check: false, current: data.value })
      } else {
        this.$set(data, 'check', false)
      }
    },
    // 清空全部
    clearTag({ list }) {
      clearTagOfData(list, this)
    },
    wrapGameGroupData(ptomGroupGames) {
      return ptomGroupGames.map((ret) => {
        return {
          id: ret.groupId,
          value: ret.groupName,
          name: ret.groupName
        }
      })
    },
    preload() {
      Promise.all([getPtomGroupGames(), getMiddleGameList()]).then((data) => {
        const [ptomGroupGames, middleGameList] = data
        isArray(ptomGroupGames) && (this.gameGroupData = this.wrapGameGroupData(ptomGroupGames))
        isArray(middleGameList) && (this.midGameData = middleGameList)
      })
    },
    queryGame(info) {
      this.filter = info
    }
  },
  data() {
    return {
      gameGroupData: [],
      midGameData: [],
      filter: {}
    }
  },
  created() {
    this.preload()
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog {
  position: relative;
  z-index: 99;
}

.m-foot {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
